module.exports = __webpack_public_path__ + "img/vehicle.19f387a6.svg";